import { render, staticRenderFns } from "./WarningLabUnPublish.vue?vue&type=template&id=cb288e68&scoped=true"
import script from "./WarningLabUnPublish.vue?vue&type=script&lang=js"
export * from "./WarningLabUnPublish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb288e68",
  null
  
)

export default component.exports